<template>
    <div>
        <div>
            <router-link :to="{ name: 'app' }" v-if="logoUrl">
                <img class="max-w-100 mx-auto d-flex" alt="logo" :src="logoUrl" />
            </router-link>
        </div>
        <div>
            <Menu
                theme="dark"
                :mode="stateAppLayout.isMobile ? 'inline' : 'vertical'"
                :inlineIndent="12"
                v-model:openKeys="stateAppLayout.openKeys"
                v-model:selectedKeys="stateAppLayout.selectedKeys"
            >
                <AppMenuItem v-for="menu in stateAppLayout.menuSides" :key="menu.id" :menu="menu"></AppMenuItem>
            </Menu>
        </div>
    </div>
</template>

<script>
import { computed, defineComponent, defineAsyncComponent, watch } from "vue";
import { getLogoUrl } from "../../../app.logic";
import { state as stateAppLayout, refreshSidebar } from "./app-layout.logic";
import { Menu } from "ant-design-vue";
import { useRoute } from "vue-router";

export default defineComponent({
    components: {
        Menu,
        AppMenuItem: defineAsyncComponent(() => import("./AppMenuItem")),
    },
    setup() {
        const route = useRoute();
        const logoUrl = computed(() => getLogoUrl());
        watch(
            () => route.path,
            () => refreshSidebar(),
            { flush: "post" }
        );
        return { stateAppLayout, logoUrl };
    },
});
</script>
